export enum UserType {
    PUBLISHER = 'PUBLISHER',
    ADVERTISER = 'ADVERTISER',
    ADMIN = 'ADMIN',
    CORPORATION = 'CORPORATION',
}
